import { StateType, TaxSelectedType } from 'Types/common';
import { TaxStateType } from './reducer';

export const taxSelectedSelector = (state: StateType<TaxStateType>): TaxSelectedType =>
  state?.tax?.taxSelected;
